<app-modal [isOpen]="isOpen" size="md" [contentStyle]="{ 'max-width': '40rem' }" title="Book Medicine"
  subtitle="Search the patient by mobile number to start an order" (closed)="close()">
  <div class="flex flex-col gap-4">
    <div class="relative">
      <app-icon name="search" [size]="14"
        class="absolute left-3 top-1/2 -translate-y-1/2 text-content2 pointer-events-none"></app-icon>
      <input type="tel" class="input input-sm input-block pl-9" placeholder="Enter mobile number" inputmode="tel"
        autocomplete="off" [ngModel]="mobile" (ngModelChange)="onMobileChange($event)" />
    </div>

    <div *ngIf="isSearching" class="text-xs text-gray-500 flex items-center gap-2">
      <span class="loading loading-spinner loading-xs"></span> Searching...
    </div>

    <div *ngIf="errorMessage" class="text-xs text-red-600">{{ errorMessage }}</div>

    <!-- Matches -->
    <div *ngIf="!isSearching && patients.length"
      class="border border-gray-200 rounded-xl overflow-hidden max-h-72 overflow-y-auto">
      <table class="w-full text-left border-collapse text-sm">
        <thead class="border-b border-gray-200 sticky top-0 bg-gray-50">
          <tr>
            <th class="table-header">Patient ID</th>
            <th class="table-header">Name</th>
            <th class="table-header">Telecaller</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let p of patients" class="border-b last:border-b-0 hover:bg-gray-50 transition cursor-pointer"
            tabindex="0" (click)="selectPatient(p)" (keydown.enter)="selectPatient(p)">
            <td class="table-item text-gray-600">{{ p.patient_pid || '—' }}</td>
            <td class="table-item">
              <div class="font-medium">{{ p.name }}</div>
              <div class="text-xs text-gray-500 mt-0.5 font-normal">{{ p.contact_number }}</div>
            </td>
            <td class="table-item text-gray-600">{{ p.telecaller || 'Unassigned' }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- No match -->
    <div *ngIf="!isSearching && hasSearched && !patients.length && !errorMessage"
      class="flex flex-col items-center gap-3 py-4 text-center">
      <p class="text-sm text-gray-600 m-0">No patient found for “{{ mobile }}”.</p>
      <button type="button" class="btn btn-primary" (click)="newPatient()">
        <app-icon name="add" [size]="16"></app-icon> New patient
      </button>
    </div>
  </div>
</app-modal>